module.exports = __webpack_public_path__ + "static/img/flags.9c96e0ed.9c96e0e.png";


//////////////////
// WEBPACK FOOTER
// ./~/vue-phone-number-input/dist/img/flags.9c96e0ed.png
// module id = 1033
// module chunks = 0